import { style, animate, trigger, transition, keyframes, query } from '@angular/animations';

const fadeTiming = 100;

export const fadeWidthInOutAnimation =
  trigger('fadeWidthInOut', [
    transition(':enter', [
      animate(`${fadeTiming}ms ${fadeTiming}ms ease`, keyframes([
        style({ width: '0px', opacity: 0, offset: 0 }),
        style({ width: '*', opacity: 0, offset: 0.5 }),
        style({ width: '*', opacity: 1, offset: 1 }),
      ])),
    ]),
    transition(':leave', [
      animate(`${fadeTiming}ms ease`, keyframes([
        style({ width: '*', opacity: 1, offset: 0 }),
        style({ width: '*', opacity: 0, offset: 0.5 }),
        style({ width: '0px', opacity: 0, offset: 1 }),
      ])),
    ]),
  ]);


export const heightChangeAnimation =
  trigger('heightChange', [
    transition('* => void', [
      query(':self', [
        style({ opacity: 0 }),
      ]),
    ]),
    transition('void => *', [
      query(':self', [
        style({ height: '{{startHeight}}px' }),
      ], { params: { startHeight: '{{startHeight}}' } }),
    ]),
    transition('* <=> *', [
      query(':self', [
        style({ height: '{{startHeight}}px' }),
        animate('150ms ease', style({ height: '*' })),
      ], { params: { startHeight: '{{startHeight}}' } }),
    ]),
  ]);


export const expandWidthAnimation =
  trigger('expandWidth', [
    transition(':enter', [
      style({ maxWidth: '0px', opacity: 0 }),
      animate('500ms ease', style({ maxWidth: '300px', opacity: 1 })),
    ]),
  ]);



